import styled from "styled-components";
import BgGradient2 from "./assets/background.png";

export const IndexmodelComponentMainDiv = styled.div`
  height: 316px;
  width: 1px;
  flex: 1;

  border-radius: 12px;
  > div {
  }
  .gradient-background {
    background: rgba(0, 0, 0, 1);
    width: 100%;
    height: 316px;
    background-size: cover;
    background-repeat: no-repeat;
    border-radius: 12px;
    background-image: url(${BgGradient2});
  }

  .model-icon-holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 24px;
    gap: 24px;
    width: 100%;
    height: min-content;
  }
  .model-icon-container {
    width: 100%;
    height: inherit;
    display: flex;

    align-items: center;
    justify-content: center;
    border-radius: 16px;
    overflow: hidden;
  }
`;

export const IndexmodelComponentModleContainer = styled.div`
  transition: all 1s;
  cursor: pointer;

  .model-container {
    display: flex;
    flex: none;
  }
  .ring {
    transition: all 0.2s;

    width: 48px;
    height: 48px;
    backdrop-filter: blur(3px);
    border: 1px solid var(--border-color-w1);
    background: rgba(255, 255, 255, 0.09);
    border-radius: 100000px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .icon {
      transition: inherit;

    width: 28px;
    height:28px;
  }
  &:hover {
    .ring {
      width: 58px;
      height: 58px;
      > svg {
        width:  38px;
        height: 38px;
      }
    }
  }
`;
